import React, { useCallback, useState } from "react";
import { Box, Typography, List, ListItem, IconButton } from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload"; 
import DeleteIcon from "@material-ui/icons/Delete";
import { useDropzone } from "react-dropzone";
 
const FileUpload = (props) => {
  const [multiFileWarning, setMultiFileWarning] = useState(false);

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 1) {
      setMultiFileWarning(true);
      setTimeout(() => setMultiFileWarning(false), 3000);
    }
    // Only keep the most recent file — one at a time
    props.setFiles(acceptedFiles.slice(0, 1));
  }, []);

  const onDropRejected = useCallback((rejectedFiles) => {
    if (rejectedFiles.length > 1) {
      setMultiFileWarning(true);
      setTimeout(() => setMultiFileWarning(false), 3000);
    }
  }, []);
 
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    onDropRejected,
    multiple: false,
  });
 
  const handleRemove = (file) => {
    props.setFiles((prev) => prev.filter((f) => f !== file));
  };
 
  return (
    <Box>
      {/* Drag & Drop Area */}
      <Box
        {...getRootProps()}
        sx={{
          border: "2px dashed",
          borderColor: isDragActive ? "primary.main" : "grey.400",
          borderRadius: 2,
          p: 4,
          textAlign: "center",
          cursor: "pointer",
          bgcolor: isDragActive ? "action.hover" : "background.paper",
          transition: "0.3s",
        }}
      >
        <input {...getInputProps()} />
        <CloudUploadIcon sx={{ fontSize: 40, color: "primary.main" }} />
        <Typography variant="body1" mt={2}>
          {isDragActive
            ? "Drop your file here!"
            : "Drag & drop a file here, or click to select one"}
        </Typography>
        <Typography variant="caption" color="textSecondary" mt={1}>
          Only one file can be uploaded at a time.
        </Typography>
        {multiFileWarning && (
          <Typography variant="caption" style={{ color: "#c0392b", display: "block", marginTop: 6 }}>
            Only one file can be uploaded at a time. Please select a single file.
          </Typography>
        )}
      </Box>
 
      {/* File List */}
      {props?.files?.length > 0 && (
        <List  sx={{ mt: 2 }}>
          {props?.files?.map((file, index) => (
            <ListItem
              key={index}
              className="d-flex justify-content-between"
            >
             <label className="text-primary">{file.name} </label> &nbsp;
              <IconButton style={{color: "red"}} onClick={() => handleRemove(file)}>
                  <DeleteIcon />
                </IconButton>
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  );
};
 
export default FileUpload;
 